import React from 'react';

import Close from '@swf/core/assets/icons/close.svg';

import Alert from '../../../../../Alert/Alert';

import { preview, wrapper } from './UploadSuccess.scss';

interface Props {
  acceptedFile: File;
  onDelete: () => void;
}

const UploadSuccess: React.FC<Props> = ({ acceptedFile, onDelete }) => (
  <Alert variant="success" className={wrapper}>
    <span className={preview}>{acceptedFile.name}</span>
    <Close onClick={onDelete} />
  </Alert>
);

export default UploadSuccess;
